addEventListener('DOMContentLoaded', () => {
	const lists = document.body.querySelectorAll('.list-block .items.scroll-list')
	lists.forEach(initializeScroll)
})

function initializeScroll(element) {
    const button = element.querySelector('button.next')

    function onScroll() {
        const canScrollRight = element.scrollLeft < element.scrollWidth - element.offsetWidth
        button.toggleAttribute('hidden', !canScrollRight)
    }

    function onResize() {
        element.dataset.scrollable = element.scrollWidth > element.offsetWidth
        onScroll()
    }

    function scrollRight() {
        element.scrollBy({left: element.offsetWidth, behavior: 'smooth'})
    }

    element.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onResize, { passive: true })
    button.addEventListener('click', scrollRight)

    onResize()
}

